// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#prepayments-screen .integrations-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
#prepayments-screen .integrations-wrapper[data-columns='1'] > div {
  width: 100%;
}
#prepayments-screen .integrations-wrapper[data-columns='2'] > div {
  width: 48%;
}
#prepayments-screen .integrations-wrapper[data-columns='3'] > div {
  width: 31.333%;
}
#prepayments-screen .integrations-wrapper[data-columns='4'] > div {
  width: 23%;
}
#prepayments-screen .integrations-wrapper .pre-payment-card {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  padding: 1.5rem 2rem;
}
#prepayments-screen .prepayment-value-wrapper {
  display: flex;
  margin-top: 1rem;
  gap: 1rem;
  height: min-content;
}
#prepayments-screen .prepayment-value-wrapper > div:nth-child(1) {
  width: 60%;
}
#prepayments-screen .prepayment-value-wrapper > div:nth-child(2) {
  width: 40%;
}
@media (max-width: 768px) {
  #prepayments-screen .prepayment-value-wrapper {
    flex-direction: column;
  }
  #prepayments-screen .prepayment-value-wrapper > div {
    width: 100% !important;
  }
}
#prepayments-screen .receivable-list-wrapper {
  margin-top: 1rem;
}
#prepayments-screen .receivable-history-wrapper {
  margin-top: 1rem;
}
.ant-spin-nested-loading > div > .ant-spin.prepayment-spin {
  height: 100vh;
  max-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(0.5rem);
}
.no-integrations-message .title {
  font-weight: 600;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  line-height: 32px;
  letter-spacing: -0.05em;
  text-align: left;
}
.no-integrations-message .subtitle {
  font-size: 1rem;
  font-weight: 400;
  font-family: Poppins;
  line-height: 19px;
  letter-spacing: -0.03em;
}
`, "",{"version":3,"sources":["webpack://./src/screens/PrePaymentScreen/styles.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,eAAA;EACA,SAAA;AAAJ;AAGM;EACE,WAAA;AADR;AAMM;EACE,UAAA;AAJR;AASM;EACE,cAAA;AAPR;AAYM;EACE,UAAA;AAVR;AAhBA;EA+BM,sCAAA;EACA,kCAAA;EACA,oBAAA;AAZN;AArBA;EAsCI,aAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,UAAA;AAdN;AAiBI;EACE,UAAA;AAfN;AAkBI;EAAA;IACE,sBAAA;EAfJ;EAiBI;IACE,sBAAA;EAfN;AACF;AAzCA;EA6DI,gBAAA;AAjBJ;AA5CA;EAiEI,gBAAA;AAlBJ;AAqBA;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAnBF;AAsBA;EAEI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AArBJ;AAcA;EAUI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,uBAAA;AArBJ","sourcesContent":["#prepayments-screen {\n  .integrations-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n\n    &[data-columns='1'] {\n      & > div {\n        width: 100%;\n      }\n    }\n\n    &[data-columns='2'] {\n      & > div {\n        width: 50% - 2rem;\n      }\n    }\n\n    &[data-columns='3'] {\n      & > div {\n        width: 33.333% - 2rem;\n      }\n    }\n\n    &[data-columns='4'] {\n      & > div {\n        width: 25% - 2rem;\n      }\n    }\n\n    .pre-payment-card {\n      background-color: var(--primary-color);\n      border-color: var(--primary-color);\n      padding: 1.5rem 2rem;\n    }\n  }\n\n  .prepayment-value-wrapper {\n    display: flex;\n    margin-top: 1rem;\n    gap: 1rem;\n    height: min-content;\n\n    & > div:nth-child(1) {\n      width: 60%;\n    }\n\n    & > div:nth-child(2) {\n      width: 40%;\n    }\n\n    @media (max-width: @md-screen) {\n      flex-direction: column;\n\n      & > div {\n        width: 100% !important;\n      }\n    }\n  }\n\n  .receivable-list-wrapper {\n    margin-top: 1rem;\n  }\n\n  .receivable-history-wrapper {\n    margin-top: 1rem;\n  }\n}\n.ant-spin-nested-loading > div > .ant-spin.prepayment-spin {\n  height: 100vh;\n  max-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(0.5rem);\n}\n\n.no-integrations-message {\n  .title {\n    font-weight: 600;\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n    line-height: 32px;\n    letter-spacing: -0.05em;\n    text-align: left;\n  }\n  .subtitle {\n    font-size: 1rem;\n    font-weight: 400;\n    font-family: Poppins;\n    line-height: 19px;\n    letter-spacing: -0.03em;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
